import { MARQUEE_ITEMS } from "../data/site";

const Strip = () => (
  <div className="flex items-center shrink-0">
    {MARQUEE_ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="font-display text-lg sm:text-xl font-bold uppercase tracking-[0.15em] text-zinc-400 px-8">
          {item}
        </span>
        <span className="w-2 h-2 rotate-45 bg-gradient-to-br from-[#FF2A2A] to-[#FF6B00] shrink-0" />
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <div
      data-testid="marquee-strip-container"
      className="relative overflow-hidden border-y border-white/10 bg-[#0D0D0F] py-5"
    >
      <div className="marquee-track">
        <Strip />
        <Strip />
      </div>
    </div>
  );
}
